import React from 'react';

const OrdersTableSkeleton = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row w-full">
        <div className="flex w-full justify-center md:hidden pb-2">
          <button className={`p-2 font-bold border-b px-6`}>Buy Orders</button>
          <button className={`p-2 font-bold border-b px-6`}>Sell Orders</button>
        </div>
        {[...Array(2)].map((_, index) => (
          <div className="w-full">
            <div className="w-full">
              <div className="pb-4 px-2">
                <h3 className="text-md font-bold text-center mb-2 bg-gray-200 animate-pulse rounded-lg h-6 w-3/4 mx-auto"><span className="opacity-0">Buy Orders</span></h3>
                <table className="min-w-full rounded-lg">
                  <thead>
                    <tr className="animate-pulse rounded-lg">
                      <th className="py-3 px-6 bg-gray-200 h-4 w-1/4"></th>
                      <th className="py-3 px-6 bg-gray-200 h-4 w-1/4"></th>
                      <th className="py-3 px-6 bg-gray-200 h-4 w-1/4"></th>
                      <th className="py-3 px-6 bg-gray-200 h-4 w-1/4 hidden lg:block"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(6)].map((_, index) => (
                      <tr key={index} class="border-b text-right animate-pulse rounded-lg">
                        <td class="py-4 px-6 bg-gray-200"><span className="opacity-0">Ƚ120,000</span></td>
                        <td class="py-4 px-6 bg-gray-200"><span className="opacity-0">$0.00350</span></td>
                        <td class="py-4 px-6 bg-gray-200"><span className="opacity-0">$420</span></td>
                        <td class="py-4 px-6 bg-gray-200 hidden lg:block text-center"><span className="opacity-0">05/09/2024, 11:00</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center my-4">
        <button
          className="bg-gray-200 font-bold py-2 px-4 rounded animate-pulse rounded-lg"
        >
          <span className="opacity-0">Show More</span>
        </button>
      </div>
    </>


  )
}

export default OrdersTableSkeleton;